import { Component, OnInit, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { DashboardComponent } from '../dashboard.component';
import { PartnersComponent } from '../partners/partners.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {PageEvent} from '@angular/material/paginator';
import {MatChipInputEvent} from '@angular/material/chips';

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import { MatAccordion } from '@angular/material/expansion';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};


@Component({
  selector: 'app-spendings',
  templateUrl: './spendings.component.html',
  styleUrls: ['./spendings.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class SpendingsComponent implements OnInit {

  @ViewChild('SpendingsAccordion') SpendingsAccordion: MatAccordion;
  Currencies:any[];
  DecimalPrecisions:any[];
  VATRates:any[];
  Periods:any[];
  DocumentStatuses:any[];
  Countries:any[];
  Payments:any[];
  SpendingPayments:any[];
  PaymentsTotals:any[];
  DeductibilityTypes:any[];

  Filter: {[k: string]: any} = {};
  Totals: any[];
  PaidTotals:any[];
  currentPartner:any;
  currentSpending:any;
  Partners:any[];
  NewSpending:{[k: string]: any} = {};

  Spendings:any[];
  showFilter:boolean;
  ShowDeleteSpendingQuestion:boolean;
  loading:boolean;
  showEditSpendingPopUp:boolean;
  searchTerm:string;
  resultsLength = 0;
  pageSize = 999999;
  countryID:number;
  selectedFile: File = null;
  newBlogForm: FormGroup;
  ShowNewSpendingContainer:boolean;
  ShowPaymentsContainer:boolean;
  ShowDeletePaymentQuestion:boolean;

  activeFilters:{[k: string]: any} = [];

  FromDate = new FormControl(moment());
  ToDate = new FormControl(moment());

  CreatingDate = new FormControl(moment());
  DueDate = new FormControl(moment());
  CollectionDate = new FormControl(moment());

  AllSelected:boolean;

  constructor(public parent: DashboardComponent, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private route: ActivatedRoute, private router:Router) { }

  ngOnInit(): void {
    this.showFilter = false;
    this.InitializeFilter();
    this.GetSpendingsMasterData();
    this.GetSpendingsFiltered();
    this.countryID = null;
    this.NewSpending = null;
    this.GetPaymentsMasterData();

    this.newBlogForm = new FormGroup({
      Name: new FormControl(null),
      UploadedFile: new FormControl(null)
    });
  }

  GetPartnersFiltered(searchTerm:string, CountryID:number, resetPaging:boolean){
    var request = {
      SearchTerm:searchTerm,
      CountryID:CountryID,
      PageIndex:1,
      PageSize:this.pageSize,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Company:this.parent.Company
    };

    if(this.searchTerm.length >= 3){
      this.parent.loading = true;

      this.service.GetPartnersFiltered(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Partners = response["Partners"];
         this.resultsLength = response["Count"];
        }
     
        this.parent.loading = false;
      });
    }
  }

  GetSpendingsMasterData(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.service.GetSpendingsMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Currencies = response["Currencies"];
        this.DecimalPrecisions = response["DecimalPrecisions"];
        this.VATRates = response["VATRates"];
        this.Periods = response["Periods"];
        this.DocumentStatuses = response["DocumentStatuses"];
        this.Countries = response["Countries"];
        this.DeductibilityTypes = response["DeductibilityTypes"];
      }
   
      this.parent.loading = false;
    });
  }

  InitializeFilter(){

    this.Filter = {};
    this.Filter.FromDate = null;
    this.Filter.ToDate = null;
    this.Filter.Partner = {};
    this.Filter.DocumentStatus = {};
    this.Filter.Period = {};
    this.Filter.Period = null;
    this.Filter.Country = {};
    this.Filter.Country = null;
    this.Filter.Currency = {};
    this.Filter.Currency = null;

    this.Filter.Pager = {};
    this.Filter.Pager.PageIndex = 1;
    this.Filter.Pager.PageSize = 25;
    this.Filter.Pager.TotalCount = 0;
  }

  InitializeNewSpending(){
    this.currentSpending = {};
    this.currentSpending.Partner = {};
    this.currentSpending.EditMode = true;
    this.currentSpending.DocumentDate = null;
    this.currentSpending.DueDate = null;
    this.currentSpending.VAT = null;
    this.currentSpending.Value = null;
    this.currentSpending.PaidValue = null;
    this.currentSpending.VATPaidValue = null;
    this.currentSpending.Currency = null;
    this.currentSpending.ShowMore = null;
    this.currentSpending.DecimalPrecision = {};
    this.currentSpending.DecimalPrecision.ID = 2;

    this.currentSpending.Deductibility = {};
    this.currentSpending.Deductibility.Type = {};
    this.currentSpending.Deductibility.Type.ID = 0;
    this.currentSpending.Deductibility.Value = 100;

    this.searchTerm = "";
    this.ShowNewSpendingContainer = true;
  }

  onSelectFile(fileInput: any) {
    this.selectedFile = <File>fileInput.target.files[0];
  }

  CloseNewSpending(){
    this.NewSpending = null;
    this.ShowNewSpendingContainer = false;
  }

  GetSpendingsFiltered(page = 1){

    this.Filter.Pager.PageIndex = page;

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
      this.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
      this.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
    }
    
    this.showFilter = false;

    this.service.GetSpendingsFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Spendings = response["Spendings"];
        this.Totals = response["Totals"];
        this.PaidTotals = response["PaidTotals"];

        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));
        this.AllSelected = false;
      }
    });

    this.GetSpendingsFilteredCOUNT();
  }

  GetSpendingsFilteredCOUNT(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
      this.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
      this.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
    }

    this.service.GetSpendingsFilteredCOUNT(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Filter.Pager = response["Pager"];

        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));
      }
   
    });
  }

  ClearPeriod(){
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
    this.Filter.Period = null;

  }

  DisablePeriod(){
    this.Filter.Period = null;
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
  }

  AddActiveFilter(filterName:string, filterType:string){
    var filter = {
      ID:this.parent.newGuid(),
      Name:filterName,
      Type:filterType
    };
    
    if(this.Filter.Administration != null && this.activeFilters.find(x => x.Type == filterType)){
      this.showFilter = false;
      this.GetSpendingsFiltered();
    }

    this.activeFilters = this.activeFilters.filter(x => x.Name != filterName && x.Type != filterType);
    this.activeFilters.push(filter);

    if(filterType == "Period"){
      this.Filter.FromDate = null;
      this.Filter.ToDate = null;

      this.FromDate = new FormControl(moment(this.Filter.FromDate));
      this.ToDate = new FormControl(moment(this.Filter.ToDate));
    }
  }

  RemoveActiveFilter(ID:string, filterType:string){
    this.activeFilters = this.activeFilters.filter(x => x.ID != ID);

    if(filterType == "Administration"){
      this.Filter.Administration = null;
    }
    else if(filterType == "Series"){
      this.Filter.AccountingSeries = null;
    }
    else if(filterType == "DocStatus"){
      this.Filter.DocumentStatus = null;
    }
    else if(filterType == "DocumentNumber"){
      this.Filter.DocumentNumber = null;
    }
    else if(filterType == "Product"){
      this.Filter.Product = null;
    }
    else if(filterType == "Partner"){
      this.Filter.Partner = null;
    }
    else if(filterType == "Period"){
      this.Filter.Period = null;
    }
    else if(filterType == "Country"){
      this.Filter.Country = null;
    }
    else if(filterType == "Currency"){
      this.Filter.Currency = null;
    }

    this.GetSpendingsFiltered();
}

compareFn(c1: any, c2: any): boolean {
  return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
}

SelectNewSpendingPartner(p:any){

  this.NewSpending.Partner = p;

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Company:this.parent.Company,
    Spending:this.NewSpending
  };
  
    this.parent.loading = true;

    this.service.PrepareNewSpendingDataOnPartnerSelect(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.NewSpending = response["NewSpending"];

        this.CreatingDate = new FormControl(moment(this.NewSpending.DocumentDate));
        this.DueDate =  new FormControl(moment(this.NewSpending.DueDate));
      }
   
      this.parent.loading = false;
    });
}

SelectSpendingPartner(p:any){

  this.currentSpending.Partner = p;

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Company:this.parent.Company,
    Spending:this.currentSpending
  };
  
    this.parent.loading = true;

    this.service.PrepareNewSpendingDataOnPartnerSelect(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.currentSpending = response["NewSpending"];

        this.CreatingDate = new FormControl(moment(this.currentSpending.DocumentDate));
        this.DueDate =  new FormControl(moment(this.currentSpending.DueDate));
      }
   
      this.parent.loading = false;
    });
}

AddUpdateSpending(spending:any){

  if(this.CreatingDate.value._d != undefined){
    spending.DocumentDate = JSON.parse(JSON.stringify(this.CreatingDate.value._d.toLocaleDateString()));
  }

  if(this.DueDate.value._d != undefined){
    spending.DueDate = JSON.parse(JSON.stringify(this.DueDate.value._d.toLocaleDateString()));
  }

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Spending:spending,
  };
  
    this.parent.loading = true;

    this.service.AddUpdateSpending(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.GetSpendingsFiltered();
        var returnID = response["ID"];

        if(returnID > 0){
          this.UploadSpendingFile(returnID);
        }
        else{
          this.UploadSpendingFile(this.currentSpending.ID);
        }

        this.CloseNewSpending();
        this.GetSpendingsFiltered();
      }
   
      this.parent.loading = false;
    });
}

UploadSpendingFile(SpendingID:any){
    
  const request = new FormData();
  request.append('User.Id', JSON.stringify(this.parent.User.Id));
  request.append('Language', this.parent.getLanguage());
  request.append('SpendingID', SpendingID);
  request.append('UploadedFile', this.selectedFile);
  request.append('CompanyID', this.parent.Company.ID);

  this.parent.loading = true;

  this.service.UploadSpendingFile(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.parent.openSnackBar("Success", "OK", "light-info-snackbar");
    }
   
    this.parent.loading = false;
  });
}

OpenSpendingEdit(s:any){

  s.ShowMore = true;
  this.currentSpending = s;
  this.searchTerm = this.currentSpending.Partner.Name;
  this.NewSpending = null;

  this.CreatingDate = new FormControl(moment());
  this.DueDate = new FormControl(moment());
  this.CreatingDate = new FormControl(moment(this.currentSpending.DocumentDate));
  this.DueDate = new FormControl(moment(this.currentSpending.DueDate));
}

download(filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

DownloadSpendingFile(s:any){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SpendingID:s.ID,
  };

  this.parent.loading = true;

  this.service.DownloadSpendingFile(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var Document = response["Document"];
      this.download(Document.Name, Document.PDFStream);
    }

    this.parent.loading = false;
  });
}

CancelOrActivateSpending(SpendingID:string,CancelSpending:boolean){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SpendingID:SpendingID,
    CancelSpending:CancelSpending,
  };

  this.loading = true;

  this.service.CancelOrActivateSpending(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
     this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
     this.GetSpendingsFiltered();
    }

    this.loading = false;

  });

}

DeleteSpending(SpendingID:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SpendingID:SpendingID,
  };

  this.parent.loading = true;

  this.service.DeleteSpending(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Spendings = this.Spendings.filter(x => x.ID != SpendingID);
      this.ShowDeleteSpendingQuestion = false;
      this.currentSpending = null;
    }

    this.parent.loading = false;
  });
}

GetCurrencyLiveExchange(currency:any){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Currency:currency
  };

  this.parent.loading = true;

  this.service.GetCurrencyLiveExchange(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){

      if(this.NewSpending != null){
        this.NewSpending.Currency = response["Currency"];
      }

      if(this.currentSpending != null){
        this.currentSpending.Currency = response["Currency"];
      }
    }
 
    this.parent.loading = false;
  });
}

RemoveSpendingFile(SpendingID:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SpendingID:SpendingID,
  };

  this.parent.loading = true;

  this.service.RemoveSpendingFile(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.currentSpending.FilePath = null;
    }

    this.parent.loading = false;
  });
}

GetSpendingPayments(SpendingID:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SpendingID:SpendingID
  };

  this.parent.loading = true;

  this.service.GetSpendingPayments(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.SpendingPayments = response["Payments"];
      this.PaymentsTotals = response["Totals"];
      this.ShowPaymentsContainer = true;
      this.SearchedSpendings = null;
      this.Receptions = null;
      var c = this.currentSpending;
    }

    this.parent.loading = false;
  });
}

GetPaymentsMasterData(){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
  };

  this.service.GetPaymentsMasterData(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.BankAccounts = response["BankAccounts"];
      this.PaymentTypes = response["PaymentTypes"];
      this.PaymentCategories = response["PaymentCategories"].filter(x => x.ID != -1);
    }
 
    this.parent.loading = false;
  });
}

ReselectBankAccount(c:any){
  this.currentPayment.BankAccount = this.BankAccounts.filter(x => x.Currency.ID == c.ID)[0];
}

currentPayment:any;
PaymentCategories:any[];
BankAccounts:any[];
ShowPaymentContainer:boolean;
Receptions:any[];
SearchedSpendings:any[];
PaymentTypes:any[];

ClonePayment(c:any){
  this.currentPayment = JSON.parse(JSON.stringify(c));

  this.PaymentCategories.forEach(c => {
    if(c.ID == this.currentPayment.Category.ID){
      this.currentPayment.Category = c;
    }
  });

  this.CollectionDate = new FormControl(moment(this.currentPayment.CollectionDate));

  if(this.currentPayment.BankAccount == null){
    this.ReselectBankAccount(this.currentPayment.Currency);
  }

  this.SearchedSpendings = null;
  this.Receptions = null;
}

SearchReceptions(s:string){

  if(s.length > 2){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      SearchTerm:s,
      WithPartnerInfo:true
    };

    this.service.SearchReceptions(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Receptions = response["Receptions"];
      }
   
      this.parent.loading = false;
    });
  }
}

SearchSpendings(s:string){

  if(s.length > 2){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      SearchTerm:s,
    };

    this.service.SearchSpendings(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.SearchedSpendings = response["Spendings"];
      }
   
      this.parent.loading = false;
    });
  }
}

SelectSpendingForPaymentSearch(s:any){
  this.currentPayment.SpendingID = s.ID;
  this.currentPayment.ReceptionID = "";
  this.currentPayment.ReceptionDetailsID = null;
  this.currentPayment.DisplayValue = s.Partner.Name;
  this.currentPayment.Supplier = s.Partner;
  this.currentPayment.Status = this.DocumentStatuses.find(x => x.ID == 1);
  this.SearchedSpendings = null;
}

SelectReceptionForPaymentSearch(r:any){
  this.currentPayment.ReceptionID = r.ID;
  this.currentPayment.ReceptionDetailsID = r.Details.ID;
  this.currentPayment.DisplayValue = r.AccountingNumber.DisplayValue;
  this.currentPayment.Supplier = r.Supplier;
  this.currentPayment.SpendingID = null;
  this.currentPayment.Status = this.DocumentStatuses.find(x => x.ID == 1);
  this.Receptions = null;
}

InitializeNewPayment(s:any){
  this.ShowPaymentContainer = true; 
  this.currentPayment = {};
  this.currentPayment.Type = this.PaymentTypes[1];
  this.currentPayment.Currency = s.Currency;
  this.CollectionDate = new FormControl(moment());
  this.currentPayment.PaymentDate = JSON.parse(JSON.stringify(this.CollectionDate.value._d.toLocaleDateString()));
  this.CollectionDate = new FormControl(moment(this.currentPayment.CollectionDate));
  this.currentPayment.ID = 0;

  this.currentPayment.BankAccount = {};
  this.currentPayment.BankAccount = this.BankAccounts.filter(x => x.Currency.ID == this.currentPayment.Currency.ID)[0];

  this.currentPayment.Category = {};
  this.currentPayment.Category = this.PaymentCategories[1];

  this.currentPayment.ReceptionID = "";
  this.currentPayment.SpendingID = s.ID;
  this.currentPayment.Supplier = s.Partner;
  this.currentPayment.DisplayValue = s.Partner.Name;

  this.currentSpending = s;
}

UpdatePayment(p:any){

  if(this.CollectionDate.value._d != undefined){
    p.PaymentDate = JSON.parse(JSON.stringify(this.CollectionDate.value._d.toLocaleDateString()));
  }

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Payment:p,
  };
  
    this.parent.loading = true;

    this.service.UpdatePayment(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.GetSpending(this.currentSpending.ID);
      }
   
      this.parent.loading = false;
    });
}

AddPayment(){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Payment:this.currentPayment,
  };

  if(this.CollectionDate.value != null){
    if(this.CollectionDate.value._d != undefined){
      request.Payment.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value._d.toLocaleDateString()));
      this.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value._d.toLocaleDateString()));
    }
    else{
      request.Payment.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value));
      this.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value));
    }
  }

  this.parent.loading = true;

  this.service.AddPayment(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.GetSpending(this.currentSpending.ID);
    }
    

    this.CollectionDate = new FormControl(moment());
    this.parent.loading = false;
  });
}

openAllFirst() {
  this.SpendingsAccordion.openAll();
}
closeAllFirst() {
  this.SpendingsAccordion.closeAll();
}

DeletePayment(ID:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ID:ID,
  };

  this.parent.loading = true;

  this.service.DeletePayment(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.SpendingPayments = this.SpendingPayments.filter(x => x.ID != ID);
      this.ShowDeletePaymentQuestion = false;
      this.currentPayment = null;
      this.GetSpending(this.currentSpending.ID);
    }

    this.parent.loading = false;
  });
}

VerifyPriceModel(p:string){
  var result = this.parent.NormalizePrice(p);

  if(this.currentSpending != null){
    this.currentSpending.Value = result;
  }
}

GetSpending(ID:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ID:ID,
    WithInfo:true,
    ExchangeToMainCurrency:this.Filter.ExchangeToTargetCurrency
  };

  this.service.GetSpending(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){

      var s = response["Spending"];
      var objIndex = this.Spendings.findIndex((obj => obj.ID == ID));
      this.Spendings[objIndex] = JSON.parse(JSON.stringify(s));

      this.GetSpendingPayments(ID);
    }
 
    this.parent.loading = false;
  });
}

SelectAll(){
  this.Spendings.forEach(r => {
    r.IsSelected = this.AllSelected;
  });

  this.CheckIfAnyChecked();
}

AnyChecked:boolean;

CheckIfAnyChecked(){
  this.AnyChecked = false;

  this.Spendings.forEach(element => {
    if(element.IsSelected){
      this.AnyChecked = true;
    }
  });
}

ShowAutoPrintBulkQuestion:boolean;

AutoPrintSpendings(){

  var ids = [];

  this.Spendings.forEach(element => {
    if(element.IsSelected){
      ids.push(element.ID);
    }
  });

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SpendingsIDs:ids
  };

  this.parent.loading = true;

  this.service.AutoPrintSpendings(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }

    this.parent.loading = false;
  });
}


}
